// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__3EXzm"};